/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/folder-open': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 15',
    data: '<g _fill="none" fill-rule="evenodd" _stroke="#354046" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M12.5 4.5v-2h-7l-1-2h-4v11"/><path pid="1" d="M1.5 14.5l3-8h11l-3 8z"/></g>'
  }
})
